module.exports = __webpack_public_path__ + "img/express-consign-sfapp.eebb260.png";